<template>
  <div class="tms-report-menu">
    <div class="d-flex mb-4">
      <b-input-group size="sm" class="mc-has-search" @click="focusSearch">
        <template #prepend>
          <i class="ps-2 mc-icon icon-fill_search"></i>
        </template>
        <b-form-input
          ref="searchInput"
          v-model="search"
          type="search"
          placeholder="Cari Nama Laporan"
        />
      </b-input-group>
    </div>
    <b-row v-if="menuList.length > 0">
      <MenuCard
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu?.key ? (menu.key = $t('report.title.fleetUtilization')) : menu?.title"
        :description="
          menu?.key ? (menu.key = $t('report.description.fleetUtilization')) : menu?.description
        "
        hasHoverEffect
        @click="handleMenuClick(menu)"
      />
    </b-row>
    <McEmptyState
      v-else
      title="Laporan tidak ditemukan"
      desc="Laporan yang Anda cari tidak tersedia"
      :hasButton="false"
    />

    <Parameter
      v-if="selectedProperty === 'costManagement'"
      :title="$t('report.filters.reportParameter')"
      :value.sync="filter[selectedProperty]"
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      :reportValue="reportValueComputed"
      @submit="handleChangeActiveFilters"
    >
      <template #content>
        <InputTableFilter />
      </template>
    </Parameter>

    <Parameter
      v-if="selectedProperty === 'fleetUtilization'"
      :title="$t('report.filters.reportParameter')"
      :value.sync="filter[selectedProperty]"
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappingsFleetUtilization"
      :reportValue="reportValueComputed"
      @submit="handleChangeActiveFilters"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <InputTableFilterFleetUtilization
          :formValues="formValues"
          :fullObjects="fullObjects"
          @update:formValues="updateFormValues($event)"
          @update:fullObjects="updateFullObjects($event)"
        />
      </template>
    </Parameter>
  </div>
</template>

<script>
import MenuCard from './MenuCard'
import tmsMenuList from '../lib/tmsMenuList'
import McEmptyState from '@/components/McEmptyState'
import notFoundImage from '@/assets/images/no-data-report.png'
import Parameter from './ReportParameter.vue'
import parseFilterDataMappings from '../tms/expenses/lib/constants/parseFilterDataMappings'
import InputTableFilter from '../tms/expenses/components/InputTableFilter'
import { tableFilterFields } from '../tms/expenses/components/InputTableFilter/lib/tableFilterFields'

import InputTableFilterFleetUtilization from '../tms/fleet-utilization/components/InputTableFilter'
import parseFilterDataMappingsFleetUtilization from '../tms/fleet-utilization/lib/constants/parseFilterDataMappings'
import { tableFilterFieldsFleetUtilization } from '../tms/fleet-utilization/components/InputTableFilter/lib/tableFilterFields'

export default {
  components: {
    MenuCard,
    Parameter,
    McEmptyState,
    InputTableFilter,
    InputTableFilterFleetUtilization,
  },
  data() {
    return {
      search: '',
      activeFilters: {},
      filter: {
        costManagement: false,
        fleetUtilization: false,
      },
      fields: tableFilterFields.filter((field) => field.isShow),
      selectedProperty: null,
    }
  },
  computed: {
    parseFilterDataMappings() {
      return parseFilterDataMappings
    },
    menuList() {
      return tmsMenuList.filter(
        (menu) =>
          menu.isShown !== false && menu.title.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    notFoundImage() {
      return notFoundImage
    },
    reportValueComputed() {
      return this.selectedProperty || ''
    },
    parseFilterDataMappingsFleetUtilization() {
      return parseFilterDataMappingsFleetUtilization
    },
  },
  mounted() {
    const expensesFilter = {}
    const fleetUtilizationFilter = {}
    this.fields.forEach((val) => {
      const values = this.parseFilterDataMappings[val.name]
      if (typeof values === 'string') {
        expensesFilter[val.name] = null
        return
      }
      if (Array.isArray(values)) {
        const arrValues = []
        for (let i = 0; i < values.length; i++) {
          arrValues.push(null)
        }
        expensesFilter[val.name] = arrValues
      }
    })

    if (tableFilterFieldsFleetUtilization && Array.isArray(tableFilterFieldsFleetUtilization)) {
      tableFilterFieldsFleetUtilization
        .filter((field) => field.isShow)
        .forEach((val) => {
          const values = this.parseFilterDataMappingsFleetUtilization[val.name]
          if (typeof values === 'string') {
            fleetUtilizationFilter[val.name] = null
            return
          }
          if (Array.isArray(values)) {
            const arrValues = []
            for (let i = 0; i < values.length; i++) {
              arrValues.push(null)
            }
            fleetUtilizationFilter[val.name] = arrValues
          }
        })
    }
    this.$store.commit('report/updateExpensesFilter', expensesFilter)
    this.$store.commit('report/updateFleetUtilizationFilter', fleetUtilizationFilter)
  },
  methods: {
    handleChangeActiveFilters(filters) {
      /*
        filters is Array of Object
        example:
        [
          {
            key: 'created_on:lte',
            values: '2023-08-29T17:00:00Z'
          }
        ]
        */

      filters.forEach((filter) => {
        // to reset the filter values
        this.$delete(this.activeFilters, filter.key)

        // to prevent set the filter in activeFilters if values are null or undefined
        if (filter.values === null || filter.values === undefined) return
        // to prevent set the filter in activeFilters if values are Array with length equal to 0
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        // set the key and values in activeFilters
        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
    handleMenuClick(menu) {
      if (menu.hasModal) {
        this.selectedProperty = menu.property
        this.filter[menu.property] = true
      } else {
        this.$router.push({ name: menu.routeName })
      }
    },
    focusSearch() {
      this.$refs.searchInput.focus()
    },
  },
}
</script>

<style scoped lang="scss">
.tms-report-menu {
  background: white;
  padding: 20px;
}

:deep(.mc-has-search) {
  border-width: $input-border-width;
  border-color: $input-border-color;
  border-radius: 4px;
  border-style: solid;
  margin-left: auto;
  max-width: 300px;
  border-radius: 4px;

  // if search is disabled
  &:has(input:disabled) {
    background: $input-disabled-bg;
  }

  .clear-search-btn {
    border: none;
    background-color: transparent;
    padding: 0px;
    margin: 0px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clear-search-btn:disabled {
    cursor: default;
  }

  input {
    border: none;
    height: 37px;
  }

  .input-group-prepend,
  .input-group-append {
    border: none;
    display: flex;
    align-items: center;

    .mc-icon:before {
      font-size: 16px;
      color: $input-placeholder-color;
    }
  }
}
</style>
